module.exports = __webpack_public_path__ + "img/404 error.5a635670.png";